import { _CollectionsNamesWithSlug } from "./common.type";
import firebase from "firebase/compat/app";

export const _createJunction = async (
  collectionName: string,
  docId: string,
  arrayName: string,
  id: string
) => {
  return firebase
    .firestore()
    .collection(collectionName)
    .doc(docId)
    .set(
      {
        [arrayName]: firebase.firestore.FieldValue.arrayUnion(id),
      },
      { merge: true }
    );
};
